module.exports = __webpack_public_path__ + "img/promo6.40da01b9.jpg";